import React from 'react';

import StyledLink from './index';

function LinkIfState({
  state,
  ifStateFalse,
  ifStateTrue,
  onClick,
}) {
  return (
    <StyledLink onClick={() => onClick(!state)}>
      {
        state
          ? ifStateTrue
          : ifStateFalse
      }
    </StyledLink>
  )
}

export default LinkIfState;
